import React from 'react';
import moment from 'moment'

import './archived_details.css'

export default function ArchivedDetails ({ archivedDate }) {
  const archivedDesc = archivedDate? `Archived (${moment(archivedDate).format("DD-MM-YYYY")})` : 'Archived'
  return (
    <div className='archived-details' >{archivedDesc}</div>
  )
}


// WEBPACK FOOTER //
// ./src/views/components/archived_details/archived_details.js